module.exports = __webpack_public_path__ + "img/Flag_of_Barbados (1).f8439090.svg";